module.exports = __webpack_public_path__ + "img/rtv_logo_WH_3840x2160px-p-1600.58f3e504.png";